// extracted by mini-css-extract-plugin
module.exports = {"savePayment":"SavePayment_savePayment__3eqBH"};